import React from "react";
import { useHistory } from "react-router-dom";

import { trackEvent } from "@jsainsburyplc/id-ui-common";

import { registrationService } from "services/registration.service";
import useCookies from "hooks/useCookies";
import { scrollToTop } from "utils/scrollToTop";
import { getRegistrationOtpLink } from "utils/urls";
import { actionTypes, categoryTypes } from "constants/tracking";

import { MultiMissionHeader } from "components/MultiMissionHeader";
import PageFormat from "components/PageFormat";
import AlreadyHaveAnAccount from "components/AlreadyHaveAnAccount";
import InitiateRegistrationForm from "components/Registration/InitiateRegistrationForm";
import useDigitalDataTracking from "hooks/useDigitalTrack";

const trackFormSubmit = (action) => {
  trackEvent({
    category: categoryTypes.REGISTRATION,
    label: "Initiate Registration Form",
    action,
  });
};

const InitiateRegistrationPage = () => {
  const { setEmail } = useCookies();
  const history = useHistory();

  useDigitalDataTracking(
    "web:groceries:authentication:register:enter email",
    "authentication",
    "authRegisterEnterEmail",
    "view"
  );
  const handleSubmit = async ({ email }, actions) => {
    const { setSubmitting, setStatus } = actions;
    try {
      setSubmitting(true);
      const response = await registrationService.requestOtp(email);
      if (response.ok) {
        setEmail(email, { path: "/" });
        setSubmitting(false);
        history.push(getRegistrationOtpLink());
        trackFormSubmit(actionTypes.SUCCESS);
        return;
      } else {
        throw Error;
      }
    } catch {
      trackFormSubmit(actionTypes.ERROR);
      setStatus({ isError: true });
      setSubmitting(false);
      scrollToTop();
    }
  };

  return (
    <PageFormat>
      <div className="ln-u-margin-top*2">
        <MultiMissionHeader />
        <h1 className="ln-u-display-2 ln-u-margin-bottom">Register</h1>
        <p className="ln-u-body-2">To start, enter your email address</p>
        <InitiateRegistrationForm onSubmit={handleSubmit} />
        <AlreadyHaveAnAccount />
      </div>
    </PageFormat>
  );
};

export default InitiateRegistrationPage;
